module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-tabbed-vehicle-instructions"
  }, [_c('ActionBar', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Vehicle Instructions")]), _c('div', {
    staticClass: "fa fa-plus",
    attrs: {
      "slot": "action"
    },
    on: {
      "click": function($event) {
        _vm.add = !_vm.add
      }
    },
    slot: "action"
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.add),
      expression: "add"
    }],
    staticClass: "instruction-list"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('selectize-instructions', {
    on: {
      "optionSelected": _vm.selectInstruction
    }
  })], 1), _c('div', {
    staticClass: "columns"
  }, [(!_vm.addInProgress) ? _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.addInstruction
    }
  }, [_vm._v("Add")]) : _vm._e()])]), (_vm.addInProgress) ? _c('loading-spinner') : _vm._e()], 1), _c('div', {
    staticClass: "container"
  }, [_c('base-list', {
    ref: "baseList",
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "showPerPageSelect": false,
      "component-type": "entityList"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65c1a3b6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/VehicleInstructions.vue
// module id = 2550
// module chunks = 1